import { render, staticRenderFns } from "./Sidemenu.vue?vue&type=template&id=0032ab2c&scoped=true&"
import script from "./Sidemenu.vue?vue&type=script&lang=js&"
export * from "./Sidemenu.vue?vue&type=script&lang=js&"
import style0 from "./Sidemenu.vue?vue&type=style&index=0&id=0032ab2c&prod&lang=scss&scoped=true&"
import style1 from "./Sidemenu.vue?vue&type=style&index=1&id=0032ab2c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0032ab2c",
  null
  
)

export default component.exports